import { render, staticRenderFns } from "./ModalConfirmTazapay.vue?vue&type=template&id=155feb42&scoped=true&"
import script from "./ModalConfirmTazapay.vue?vue&type=script&lang=js&"
export * from "./ModalConfirmTazapay.vue?vue&type=script&lang=js&"
import style0 from "./ModalConfirmTazapay.vue?vue&type=style&index=0&id=155feb42&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "155feb42",
  null
  
)

export default component.exports